// extracted by mini-css-extract-plugin
export default {"PostCreate":"qf_a bhk_qr bhk_a bhk_w bhk_ea"};